// src/pages/AttendanceEntry/attendanceEntrySlice.js
import { createSlice } from "@reduxjs/toolkit";
import {
  fetchAttendance,
  fetchUsers,
  fetchLocations,
} from "./attendanceEntryThunk";
import dayjs from "dayjs";

const attendanceEntrySlice = createSlice({
  name: "attendance",
  initialState: {
    // filters: {
    //   year: new Date().getFullYear(),
    //   month: new Date().toLocaleString("default", { month: "long" }),
    //   attendanceDate: dayjs().format("YYYY-MM-DD"),
    // },
    filters: {
      year: dayjs().format("YYYY"),
      month: dayjs().format("MMMM"),
      attendanceDate: dayjs().format("YYYY-MM-DD"),
    },
    users: [],
    locations: [],
    attendanceRecords: [],
    attendanceDetails: [],
    loading: false,
    error: null,
  },
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    resetAttendance: (state) => {
      state.attendanceRecords = [];
      state.attendanceDetails = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAttendance.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAttendance.fulfilled, (state, action) => {
        state.attendanceRecords = action.payload;
        state.loading = false;
      })
      .addCase(fetchAttendance.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.users = action.payload;
      })
      .addCase(fetchLocations.fulfilled, (state, action) => {
        state.locations = action.payload;
      });
  },
});

export const { resetAttendance, setFilters } = attendanceEntrySlice.actions;
export default attendanceEntrySlice.reducer;
